<div class="vf-addr-card">
  <!-- US address toggle -->
  <div class="d-flex align-items-center justify-content-between mb-3">
    <span class="f-size-13 text-gray-600">US address</span>
    <button type="button" class="vf-addr-toggle" [class.is-on]="isUS" (click)="toggleUS()"><span class="vf-addr-knob"></span></button>
  </div>

  <!-- Name (location-list mode) -->
  <div *ngIf="showNameUrl" class="mb-3">
    <label class="vf-addr-label">Name</label>
    <input type="text" class="vf-addr-input" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" maxlength="80" placeholder="e.g. Home, Travis County Court">
  </div>

  <!-- Street -->
  <div class="mb-3">
    <label class="vf-addr-label">Street address</label>
    <input #streetInput type="text" class="vf-addr-input" [(ngModel)]="street" [ngModelOptions]="{standalone: true}" maxlength="150" placeholder="123 Main St">
  </div>

  <!-- Suite / Unit -->
  <div class="mb-3">
    <label class="vf-addr-label">Suite / Unit <span class="vf-addr-opt">(optional)</span></label>
    <input type="text" class="vf-addr-input" [(ngModel)]="suite" [ngModelOptions]="{standalone: true}" maxlength="80" placeholder="Suite 200, Unit B, Floor 3...">
  </div>

  <!-- City + State -->
  <div class="d-flex gap-12 mb-3">
    <div class="flex-1 min-w-0">
      <label class="vf-addr-label">City</label>
      <input type="text" class="vf-addr-input" [(ngModel)]="city" [ngModelOptions]="{standalone: true}" maxlength="80" placeholder="City">
    </div>
    <div class="flex-1 min-w-0">
      <ng-container *ngIf="isUS">
        <label class="vf-addr-label">State</label>
        <div class="dropdown vf-addr-state-drop w-100">
          <button type="button" class="vf-addr-input d-flex align-items-center text-left" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="stateSearch = ''">
            <span class="flex-1 text-truncate text-none" [ngClass]="state ? 'text-gray-900' : 'text-gray-400'">{{ state || 'Select state' }}</span>
            <lucide-icon name="chevron-down" [size]="14" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
          </button>
          <div class="dropdown-menu vf-addr-state-menu rounded-sm p-0">
            <div class="position-relative" (click)="$event.stopPropagation()">
              <lucide-icon name="search" [size]="14" [strokeWidth]="2" class="text-gray-400" style="position: absolute; top: 9px; left: 10px;"></lucide-icon>
              <input type="text" placeholder="Search states" autocomplete="off" class="form-control"
                [(ngModel)]="stateSearch" (ngModelChange)="onStateSearchChange()" [ngModelOptions]="{standalone: true}"
                style="background: #fff !important; border-radius: 8px 8px 0px 0px !important; border-top: none; border-left: none; border-right: none; padding-left: 30px; font-size: 14px; font-style: normal; box-shadow: none; outline: none;">
            </div>
            <div class="overflow-y-auto overflow-x-hidden" style="max-height: 200px;">
              <button class="dropdown-item d-flex align-items-center justify-content-between gap-8" type="button" *ngFor="let s of filteredStates()" (click)="selectState(s)">
                <span class="text-none">{{ s }}</span>
                <lucide-icon *ngIf="state === s" name="check" [size]="14" [strokeWidth]="2" class="text-blue-600 flex-shrink-0 no-fill"></lucide-icon>
              </button>
              <div *ngIf="filteredStates().length === 0" class="px-12 py-8 text-center"><span class="f-size-13 text-gray-400">No states match</span></div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isUS">
        <label class="vf-addr-label">State / Province</label>
        <input type="text" class="vf-addr-input" [(ngModel)]="state" [ngModelOptions]="{standalone: true}" maxlength="80" placeholder="Province / Region">
      </ng-container>
    </div>
  </div>

  <!-- ZIP (US) / Postal + Country (international) -->
  <div *ngIf="isUS" class="mb-3">
    <label class="vf-addr-label">ZIP code</label>
    <input type="text" class="vf-addr-input" [(ngModel)]="zip" [ngModelOptions]="{standalone: true}" maxlength="20" placeholder="00000">
  </div>
  <div *ngIf="!isUS" class="d-flex gap-12 mb-3">
    <div class="flex-1 min-w-0">
      <label class="vf-addr-label">Postal code</label>
      <input type="text" class="vf-addr-input" [(ngModel)]="zip" [ngModelOptions]="{standalone: true}" maxlength="20" placeholder="Postal code">
    </div>
    <div class="flex-1 min-w-0">
      <label class="vf-addr-label">Country</label>
      <input type="text" class="vf-addr-input" [(ngModel)]="country" [ngModelOptions]="{standalone: true}" maxlength="80" placeholder="Country">
    </div>
  </div>

  <!-- URL (location-list mode) -->
  <div *ngIf="showNameUrl" class="mb-3">
    <label class="vf-addr-label">URL <span class="vf-addr-opt">(optional)</span></label>
    <input type="text" class="vf-addr-input" [(ngModel)]="url" [ngModelOptions]="{standalone: true}" maxlength="300" placeholder="https://...">
  </div>

  <!-- Actions -->
  <div class="d-flex align-items-center justify-content-end gap-8">
    <button type="button" class="btn f-size-14 text-gray-700 hover:bg-gray-100 px-12 py-1 rounded-sm" (click)="cancel()">Cancel</button>
    <button type="button" class="btn bg-black text-white hover:bg-gray-800 rounded-sm px-12 h-32 f-size-14 d-inline-flex align-items-center gap-4" (click)="save()">
      <lucide-icon name="check" [size]="14" [strokeWidth]="2"></lucide-icon> Save address
    </button>
  </div>
</div>
